import DropdownSearch from './DropdownSearch';
import Ajax from '../core/Ajax';
import { loadComponents } from '../core/componentUtils';
import loadTippy from '../Tippy';
import Loading from './Loading';
import scrollTo from '../services/Viewport/scrollTo';

export default class Countries extends DropdownSearch {
    handlerUrl;

    constructor(element) {
        super(element);

        this.state = false;
    }

    prepare() {
        super.prepare();
        const self = this;

        self.handlerUrl = handlerUrl;

        // Click on map call function for display country
        // setTimeout(function () {
        //     const countryEl = document.querySelectorAll('.change-country');
        //     countryEl.forEach((el) => {
        //         el.addEventListener('click', (e) => self.clickOnCountry(e));
        //     });
        // }, 300);
    }

    clickOnCountry(e) {
        const value = e.target.getAttribute('id');

        this.loadFromApi(value, 'countries-table');
    }

    getLoader() {
        return new Loading();
    }

    selectItem(target, initSeq) {
        super.selectItem(target, initSeq);

        let value = target.dataset.value;
        let appendTo = this.element.dataset.appendTo;

        if (appendTo) {
            const elem = document.getElementById(appendTo);
            elem.value = value;

            return;
        }

        if (value && !initSeq) {
            this.loadFromApi(value, null);
        }
    }

    loadFromApi(value, slideTo) {
        if (!this.handlerUrl) {
            return;
        }

        this.getLoader().show();
        let handler = this.handlerUrl;
        let up = handler.replace('__ISO__', value);
        let self = this;

        let ajax = new Ajax();
        ajax.post(up, {}, function (payload) {
            let jsonPayload = JSON.parse(payload);
            let snippets = jsonPayload.snippets;

            Object.keys(snippets).forEach((id) => {
                const snippet = document.getElementById(id);

                if (snippet) {
                    snippet.innerHTML = snippets[id];
                }
            });

            if (slideTo) {
                // const elm = document.getElementById(slideTo);
                //
                // if (elm) {
                //     const bodyRect    = document.body.getBoundingClientRect();
                //     const elementRect = elm.getBoundingClientRect();
                //     const offset      = elementRect.top - bodyRect.top;
                //
                //     scrollTo(offset);
                // }
            }

            loadComponents();
            loadTippy();
        });
    }
}
